import { RefObject, useMemo } from "react";
import Encoder from "../../data-writer/Encoder/Encoder";
import { WriterView } from "writer/WriterView";
import CodeAssign from "./CodeAssign";
import { JobRunnerTabTypes } from "./JobRunner";
import {
  CodeFileInfo,
  JobInfoDTO,
  ScheduledTaskExtendedDTO,
  ScheduledTaskDTOTemplateInfo,
} from "../../../serviceapi/jobRunnerApi";

interface JobRunnerEditorPanelProps {
  currentTab: JobRunnerTabTypes;
  currentTask: ScheduledTaskExtendedDTO | null;
  templateInfo: ScheduledTaskDTOTemplateInfo | null;
  taskCode: any;
  encoderKey: number;
  encoderRef: RefObject<any>;
  jobRunnerViewRef: RefObject<any>;
  managementApi: any;
  readScript: boolean;
  setReadScript: (val: boolean) => void;
  codeFilesList: CodeFileInfo[];
  selectedCodeFile: CodeFileInfo | null;
  setSelectedCodeFile: (file: CodeFileInfo | null) => void;
  setFileToUpload: (file: File | null) => void;
  selectedJob: JobInfoDTO | null;
  loadTaskCode: () => void;
  uploadTaskCode: () => void;
  setIsCreateFileDialogVisible: () => void;
  createEmptyFileForJob: () => void;
  handleScriptChange: (script: string) => void;
  handleEncoderConfigUpdate: (config: any) => void;
  writerChanged: (res: boolean) => void;
  saveTaskConfig: () => void;
  saveTemplateInfo: () => void;
}

const JobRunnerEditorPanel = ({
  currentTab,
  currentTask,
  templateInfo,
  taskCode,
  encoderKey,
  encoderRef,
  jobRunnerViewRef,
  managementApi,
  readScript,
  setReadScript,
  codeFilesList,
  selectedCodeFile,
  setSelectedCodeFile,
  setFileToUpload,
  selectedJob,
  loadTaskCode,
  uploadTaskCode,
  setIsCreateFileDialogVisible,
  createEmptyFileForJob,
  handleScriptChange,
  handleEncoderConfigUpdate,
  writerChanged,
  saveTaskConfig,
  saveTemplateInfo,
}: JobRunnerEditorPanelProps) => {
  const writerValue = useMemo(
    () =>
      currentTab === JobRunnerTabTypes.TEMPLATE
        ? templateInfo ?? {}
        : currentTask || "",
    [currentTab, templateInfo, currentTask],
  );

  if (currentTab === JobRunnerTabTypes.CODE && currentTask) {
    if (currentTask.codeFileId != null) {
      return (
        <Encoder
          key={encoderKey}
          config={{ processorConfig: { script: taskCode } }}
          updateConfig={handleEncoderConfigUpdate}
          id={"A"}
          ref={encoderRef}
          managementApi={managementApi}
          readScript={readScript}
          setReadScript={setReadScript}
          closeWindow={() => setReadScript(false)}
          updateWriters={() => {}}
          onScriptChange={handleScriptChange}
        />
      );
    }

    return (
      <CodeAssign
        isCodeExist={false}
        codeFilesList={codeFilesList}
        selectedCodeFile={selectedCodeFile}
        setSelectedCodeFile={setSelectedCodeFile}
        setFileToUpload={setFileToUpload}
        loadTaskCode={loadTaskCode}
        selectedJob={selectedJob}
        uploadTaskCode={uploadTaskCode}
        setIsCreateFileDialogVisible={setIsCreateFileDialogVisible}
        createEmptyFileForJob={createEmptyFileForJob}
      />
    );
  }

  return (
    <WriterView
      writer={writerValue}
      schema={"yourSchema"}
      ref={jobRunnerViewRef}
      changed={writerChanged}
      saveCallback={
        currentTab === JobRunnerTabTypes.CONFIG
          ? saveTaskConfig
          : saveTemplateInfo
      }
    />
  );
};

export default JobRunnerEditorPanel;
